<script setup>
import EmailIcon from '@/components/icons/EmailIcon.vue'
import InstagramIcon from '@/assets/svgs/Instagram.svg'
import LinkedInIcon from '@/assets/svgs/LinkedIn.svg'
import SiteCopyright from '@/components/SiteCopyright.vue'
import TikTokIcon from '@/assets/svgs/TikTok.svg'

const emails = [
  {
    header: 'Get website and technical help',
    email: 'info@globalcareeraccelerator.org',
  },
  {
    header: 'Learn more about The Global Career Accelerator',
    email: 'enrollment@globalcareeraccelerator.org',
  },
]

const socials = [
  {
    icon: LinkedInIcon,
    link: 'https://www.linkedin.com/company/global-career-accelerator/',
  },
  {
    icon: InstagramIcon,
    link: 'https://www.instagram.com/globalcareeraccelerator/',
  },
  {
    icon: TikTokIcon,
    link: 'https://www.tiktok.com/@globalcareeraccelerator',
  },
]
</script>

<template>
  <footer class="global-footer">
    <div class="global-footer__content">
      <div class="global-footer__top-row">
        <div class="global-footer__company">
          <img
            src="https://s3.us-west-1.amazonaws.com/images.jumpstart.me/frontend/careers/gca-globe-logo-navy.svg"
            alt="Round Global Career Accelerator logo with globe"
            height="120px"
          />
          <p class="global-footer__company-description">
            All experiences and events on this platform are part of
            <a
              class="global-footer__a"
              href="https://www.podiumeducation.com/students"
              target="_blank"
              >The Global Career Accelerator</a
            >, a program created by
            <a class="global-footer__a" href="https://www.podiumeducation.com/" target="_blank"
              >Podium Education</a
            >
            in partnership with innovative universities looking to bridge the college to career gap.
          </p>
        </div>
        <div class="global-footer__links">
          <div v-for="(email, index) in emails" :key="index" class="global-footer__section">
            <span class="global-footer__header">{{ email.header }}</span>
            <div class="global-footer__link">
              <EmailIcon />
              <a class="cta__link" :href="`mailto:${email.email}`">{{ email.email }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="global-footer__bottom-row">
        <SiteCopyright />
        <div class="global-footer__socials">
          <a v-for="(social, index) in socials" :key="index" :href="social.link" target="_blank">
            <img :src="social.icon" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.global-footer {
  background: #f5f5f4;
}

.global-footer__content {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.global-footer__top-row {
  display: flex;
  gap: 96px;
  align-items: center;
  padding-top: 72px;
  justify-content: flex-start;
}

.global-footer__bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 64px;
  padding-bottom: 20px;
}

.global-footer__company {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 0px;
}

.global-footer__company-description {
  width: 638px;
  font-size: 16px;
  line-height: 155%;
  letter-spacing: 0;
  color: #3f3f3f;
}

.global-footer__links {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.global-footer__section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.global-footer__header {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  color: #262626;
}

.global-footer__link {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0;
}

.global-footer__socials {
  display: flex;
  gap: 24px;
}

.global-footer__a {
  font-weight: 700;
  text-decoration: none;
  color: #3f3f3f;
}

.global-footer__a:hover {
  text-decoration: underline;
}

@media (max-width: 1280px) {
  .global-footer__content {
    flex-direction: column;
    margin-left: 40px;
    margin-right: 40px;
  }

  .global-footer__top-row {
    flex-direction: column;
    padding-top: 40px;
    align-items: flex-start;
    gap: 48px;
  }

  .global-footer__company-description {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .global-footer__content {
    margin-left: 20px;
    margin-right: 20px;
  }

  .global-footer__company {
    flex-direction: column;
    align-items: flex-start;
  }

  .global-footer__bottom-row {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 32px;
  }
}
</style>
